<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">我的直播</li>
        <li>
          <router-link :to="{ name: 'LiveList' }" target="_blank">
            <Button
              type="primary"
              shape="circle"
              style="width: 96px; height: 28px; line-height: 28px"
              >全部直播</Button
            >
          </router-link>
        </li>
      </ul>
      <div class="course-search">
        <Input
          search
          v-model="keywords"
          @on-search="searchLive"
          placeholder="请输入直播主题名称"
        />
      </div>
    </div>
    <div class="member-main-body">
      <div class="no-data" v-show="liveList.length == 0">
        <img src="../../assets/images/v3/no-data.png" />
        <p>暂无最新直播</p>
      </div>
      <div class="live-list">
        <Timeline v-show="liveList && liveList.length > 0">
          <TimelineItem v-for="(item, index) in liveList" :key="index">
            <span
              class="live-dot living"
              slot="dot"
              v-if="item.liveStatus === 1"
            ></span>
            <span class="live-dot" slot="dot" v-else></span>
            <div class="live-date">
              <div class="live-day">
                <!-- <span>{{ item.dateTime }}</span>
                <span>{{ item.week }}</span> -->
                <span>{{ dateFormat(item.startDate, "yyyy年MM月dd") }}</span>
              </div>
              <div class="live-time">{{ item.timeHF }}</div>
            </div>
            <div class="live-item">
              <div class="live-item-info">
                <h3>{{ item.title }}</h3>
                <p class="teacher">讲师：{{ item.teacherName }}</p>
                <p class="intro">
                  {{ item.introduce }}
                </p>
              </div>
              <div
                class="live-item-btn"
                :class="{
                  disabled:
                    item.liveStatus === 0 ||
                    (item.liveStatus === 2 && item.playbackStatus !== 4),
                }"
                @click="handlePlay(item)"
              >
                <img
                  v-if="item.roomId"
                  :src="concatImageUrl(item.roomId, 150, 150)"
                />
                <img v-else src="../../assets/images/v3/live-default-lg.png" />
                <div class="live-button">
                  <span v-if="item.liveStatus === 0" class="color5"
                    >还未开始</span
                  >
                  <span v-else-if="item.liveStatus === 1" class="color0"
                    >正在直播</span
                  >
                  <span
                    v-else-if="
                      item.liveStatus === 2 && item.playbackStatus === 4
                    "
                    class="color2"
                    >观看回放</span
                  >
                  <span v-else class="color5">生成中</span>
                </div>
              </div>
            </div>
          </TimelineItem>
        </Timeline>
      </div>
      <div class="page" v-show="liveList && liveList.length > 0">
        <Page
          :total="totalCount"
          :current="pageIndex"
          :page-size="pageSize"
          @on-change="changePage"
          show-elevator
          show-total
        />
      </div>
    </div>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { study } from "../../request";
import LivePlaying from "../../components/common/LivePlaying";
import { dateFormat } from "../../utils/utils";
export default {
  mixins: [siteMixin],
  data() {
    return {
      keywords: "",
      liveList: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      errorMessage: "",
      errorModalVisible: false,
      dateFormat,
    };
  },
  computed: {},
  mounted() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      const isAllLive = ""; //值为1时为全部直播，为空时当前用户直播
      const isTryUser = this.loginUser.ugid === 6 ? "1" : "";
      study
        .getLiveList(
          this.loginUser.userId,
          this.keywords,
          this.pageIndex,
          isAllLive,
          isTryUser
        )
        .then((res) => {
          //console.log("liveList", res);
          if (res.status === 1) {
            const result = res.data.pageInfo;
            this.totalCount = result.total;
            this.liveList = result.list;
          }
        });
    },
    searchLive() {
      this.getDataList();
    },
    handlePlay(item) {
      // this.$router.push({ name: 'LiveIndex', params: { id: item.id } });
      const url = this.$router.resolve({
        name: "LiveIndex",
        params: { id: item.id },
      });
      window.open(url.href, "_blank"); //打开新窗口
      //if (item.isLook !== 1) return;
      // if (item.liveStatus === 1) {
      //   this.$router.push({ name: 'LiveIndex', params: { id: item.id } });
      // }
      // if (item.liveStatus === 2 && item.replayId) {
      //   this.$router.push({ name: 'LiveReplay', params: { id: item.id } });
      // }
    },
    changePage(page) {
      this.scrollTop();
      this.pageIndex = page;
      this.getDataList();
    },
  },
  components: {
    LivePlaying,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";
.course-search {
  margin: 14px 30px 0 0;
  /deep/.ivu-input {
    background: #f2f2f2;
    border-radius: 20px;
    padding-left: 12px;
  }
}
.live-list {
  padding: 30px;
  .live-dot {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #cfcfcf;
    border-radius: 10px;
    &.living {
      border: 1px solid #178ae0;
      background: #178ae0;
    }
  }
  .live-date {
    display: flex;
    align-items: center;
    margin-top: -3px;
    .live-day {
      font-weight: bold;
      font-size: 16px;
      span {
        margin-right: 10px;
      }
    }
    .live-time {
      padding-left: 10px;
    }
  }
  .live-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding-bottom: 50px;
    .live-item-info {
      flex: 1;
      line-height: 2;
      h3 {
        font-size: 16px;
        font-weight: 400;
      }
      p {
        height: 28px;
        &.teacher {
          color: #666;
        }
        &.intro {
          margin-top: 16px;
          color: #999;
        }
      }
    }
    .live-item-btn {
      position: relative;
      width: 150px;
      height: 150px;
      border-radius: 6px;
      cursor: pointer;
      &.disabled {
        // pointer-events: none;
        cursor: not-allowed;
      }
      overflow: hidden;
      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 150px;
        height: 150px;
        z-index: 100;
        opacity: 0.5;
      }
      .live-button {
        position: absolute;
        left: 0;
        top: 20px;
        z-index: 200;
        width: 80px;
        height: 26px;
        line-height: 26px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;
      }
    }
  }
}
.page {
  padding-bottom: 30px;
  text-align: center;
}
</style>
